var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('core-list-cell',{staticClass:"count",attrs:{"format":_vm.format,"type":"stat"}},[(!_vm.isUser)?_c('app-game-item-field-name-owners',{staticClass:"owners",attrs:{"format":_vm.format,"item":_vm.item,"max":5}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }